import { BsFullscreen, BsFullscreenExit } from "react-icons/bs";
import { RiVolumeUpFill } from "react-icons/ri";
import { HiOutlinePlayCircle, HiOutlinePauseCircle } from "react-icons/hi2";

import { useState, useRef, useEffect } from "react";
import Select from "react-select";
import axios from "axios";

function Line() {
  const audioContainerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [volume, setVolume] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const playerRef = useRef(null);
  
  const [selectedMatch, setSelectedMatch] = useState("");
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [matches, setMatches] = useState([]);
  const [meetingDetails, setMeetingDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePlayPause = () => {
    if (!isPlaying) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const enterFullscreen = () => {
    if (audioContainerRef.current) {
      if (audioContainerRef.current.requestFullscreen) {
        audioContainerRef.current.requestFullscreen();
      } else if (audioContainerRef.current.webkitRequestFullscreen) {
        audioContainerRef.current.webkitRequestFullscreen(); // Safari
      } else if (audioContainerRef.current.mozRequestFullScreen) {
        audioContainerRef.current.mozRequestFullScreen(); // Firefox
      } else if (audioContainerRef.current.msRequestFullscreen) {
        audioContainerRef.current.msRequestFullscreen(); // IE/Edge
      }
      setIsFullscreen(true);
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };


   useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        };

        const langResponse = await axios.get(
          "http://localhost:5000/api/MatchLine/GetLanguages",
          config
        );
        setLanguages(langResponse.data);

        const meetingDetailsString = localStorage.getItem("on_going_meeting");
        if (meetingDetailsString) {
          const parsedDetails = JSON.parse(meetingDetailsString);
          setMeetingDetails(parsedDetails);

          if (parsedDetails?.creator_id) {
            const matchesResponse = await axios.get(
              `http://localhost:5000/api/MatchLine/getLiveLine/${parsedDetails.creator_id}`,
              config
            );
            setMatches(matchesResponse.data);
          }
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const showVolume = () => {
    setVolume(!volume);
  };
  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
  };
  return (
    <div className="custom-box-shadow table-page-conatainer">
      <div className="dropdown-container">
        <Select
          className="w-100 react-select-container cursor-pointer border-yelo rounded"
          classNamePrefix="react-select"
          placeholder="Select Match"
          options={matches.map((match) => ({
            value: match.matchId,
            label: `${match.team1} vs ${match.team2}`,
          }))}
          value={selectedMatch}
          onChange={setSelectedMatch}
          isSearchable={true}
        />
        <br />
        <Select
          className="w-100 react-select-container cursor-pointer border-yelo rounded"
          classNamePrefix="react-select"
          placeholder="Select Language"
           options={[
            ...languages.map((language) => ({
              value: language.name,
              label: language.name,
            })),
            { value: "other", label: "Other" },
          ]}
          value={selectedLanguage}
          onChange={setSelectedLanguage}
          isSearchable={true}
        />
      </div>

      <div class="audio-container">
        <div className="audio-live">
          <audio
            ref={audioRef}
            src="https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3"
            type="audio/mp3"
            hidden
          />
          <div className="play-stop" onClick={handlePlayPause}>
            {isPlaying ? (
              <HiOutlinePauseCircle className="icon-play" />
            ) : (
              <HiOutlinePlayCircle className="icon-play" />
            )}
          </div>
          <div class="audio-controls">
            <input
              type="range"
              id="volume-control"
              min="0"
              max="1"
              step="0.1"
              value={volume}
              style={{ display: volume ? "block" : "none" }}
              className="volumeLine"
              onChange={handleVolumeChange}
            />
            <div
              className="audio-control"
              onClick={isFullscreen ? exitFullscreen : enterFullscreen}
            >
              {isFullscreen ? (
                <BsFullscreenExit className="icon-fullscreen" />
              ) : (
                <BsFullscreen className="icon-fullscreen" />
              )}
            </div>
            <div className="audio-control">
              <RiVolumeUpFill onClick={() => showVolume()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Line;
